import { render, staticRenderFns } from "./EditMsisdnFamilyDialog.vue?vue&type=template&id=0880a4d6&"
import script from "./EditMsisdnFamilyDialog.vue?vue&type=script&lang=js&"
export * from "./EditMsisdnFamilyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports